// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonGroupPaddingHorizontalLarge = 32;
var ButtonGroupPaddingHorizontalMedium = 24;
var ButtonGroupPaddingHorizontalSmall = 24;
var ButtonGroupPaddingVerticalLarge = 24;
var ButtonGroupPaddingVerticalMedium = 16;
var ButtonGroupPaddingVerticalSmall = 16;
var ButtonTabPaddingHorizontalLarge = 24;
var ButtonTabPaddingHorizontalMedium = 24;
var ButtonTabPaddingHorizontalSmall = 24;
var ButtonTabPaddingVerticalLarge = 0;
var ButtonTabPaddingVerticalMedium = 0;
var ButtonTabPaddingVerticalSmall = 0;
var NavBarPaddingHorizontalLarge = 32;
var NavBarPaddingHorizontalMedium = 24;
var NavBarPaddingHorizontalSmall = 16;
var NavBarPaddingVerticalLarge = 24;
var NavBarPaddingVerticalMedium = 16;
var NavBarPaddingVerticalSmall = 16;
var TagPaddingHorizontalLarge = 12;
var TagPaddingHorizontalMedium = 10;
var TagPaddingHorizontalSmall = 8;
var TagPaddingHorizontalXSmall = 4;
var TagPaddingVerticalLarge = 6;
var TagPaddingVerticalMedium = 2;
var TagPaddingVerticalSmall = 1;
var TagPaddingVerticalXSmall = 3;
var SpacingSemanticsAll = {
  ButtonGroupPaddingHorizontalLarge: ButtonGroupPaddingHorizontalLarge,
  ButtonGroupPaddingHorizontalMedium: ButtonGroupPaddingHorizontalMedium,
  ButtonGroupPaddingHorizontalSmall: ButtonGroupPaddingHorizontalSmall,
  ButtonGroupPaddingVerticalLarge: ButtonGroupPaddingVerticalLarge,
  ButtonGroupPaddingVerticalMedium: ButtonGroupPaddingVerticalMedium,
  ButtonGroupPaddingVerticalSmall: ButtonGroupPaddingVerticalSmall,
  ButtonTabPaddingHorizontalLarge: ButtonTabPaddingHorizontalLarge,
  ButtonTabPaddingHorizontalMedium: ButtonTabPaddingHorizontalMedium,
  ButtonTabPaddingHorizontalSmall: ButtonTabPaddingHorizontalSmall,
  ButtonTabPaddingVerticalLarge: ButtonTabPaddingVerticalLarge,
  ButtonTabPaddingVerticalMedium: ButtonTabPaddingVerticalMedium,
  ButtonTabPaddingVerticalSmall: ButtonTabPaddingVerticalSmall,
  NavBarPaddingHorizontalLarge: NavBarPaddingHorizontalLarge,
  NavBarPaddingHorizontalMedium: NavBarPaddingHorizontalMedium,
  NavBarPaddingHorizontalSmall: NavBarPaddingHorizontalSmall,
  NavBarPaddingVerticalLarge: NavBarPaddingVerticalLarge,
  NavBarPaddingVerticalMedium: NavBarPaddingVerticalMedium,
  NavBarPaddingVerticalSmall: NavBarPaddingVerticalSmall,
  TagPaddingHorizontalLarge: TagPaddingHorizontalLarge,
  TagPaddingHorizontalMedium: TagPaddingHorizontalMedium,
  TagPaddingHorizontalSmall: TagPaddingHorizontalSmall,
  TagPaddingHorizontalXSmall: TagPaddingHorizontalXSmall,
  TagPaddingVerticalLarge: TagPaddingVerticalLarge,
  TagPaddingVerticalMedium: TagPaddingVerticalMedium,
  TagPaddingVerticalSmall: TagPaddingVerticalSmall,
  TagPaddingVerticalXSmall: TagPaddingVerticalXSmall
};

export { ButtonGroupPaddingHorizontalLarge, ButtonGroupPaddingHorizontalMedium, ButtonGroupPaddingHorizontalSmall, ButtonGroupPaddingVerticalLarge, ButtonGroupPaddingVerticalMedium, ButtonGroupPaddingVerticalSmall, ButtonTabPaddingHorizontalLarge, ButtonTabPaddingHorizontalMedium, ButtonTabPaddingHorizontalSmall, ButtonTabPaddingVerticalLarge, ButtonTabPaddingVerticalMedium, ButtonTabPaddingVerticalSmall, NavBarPaddingHorizontalLarge, NavBarPaddingHorizontalMedium, NavBarPaddingHorizontalSmall, NavBarPaddingVerticalLarge, NavBarPaddingVerticalMedium, NavBarPaddingVerticalSmall, SpacingSemanticsAll, TagPaddingHorizontalLarge, TagPaddingHorizontalMedium, TagPaddingHorizontalSmall, TagPaddingHorizontalXSmall, TagPaddingVerticalLarge, TagPaddingVerticalMedium, TagPaddingVerticalSmall, TagPaddingVerticalXSmall, SpacingSemanticsAll as default };
